import { selectedViewSelector } from "./selectedViewSelector";
import { filtersFromViewCombiner } from "./filtersFromViewCombiner";
import { RootState } from "../../../../store";

export const viewAccountsFilterSelector = (state: RootState) => {
  const view = selectedViewSelector(state);

  return filtersFromViewCombiner("account", view?.filters);
};
